import React, {useEffect, useState} from "react";
import {
    Button,
    Form,
    Input,
    InputNumber,
    Modal,
    notification,
    Radio,
    Select,
    Spin,
    Table,
    Tag,
    Tooltip,
} from "antd";
import {useAuth} from "oidc-react";
import {useJwt} from "react-jwt";
import SharedService from "../../../services/shared/service";
import {DeleteOutlined, EditOutlined, FilterOutlined} from "@ant-design/icons";
import SEO from "../../../components/SEO";

const {Option} = Select;
const DocumentLabels = () => {
    const [documentLabels, setDocumentLabels] = useState([]);
    const [referenceKvps, setReferenceKvps] = useState([]);
    const [addModalVisible, setAddModalVisible] = useState(false);
    const [sortedInfo, setSortedInfo] = useState({});
    const [loading, setloading] = useState(false);
    const [inputSearchValues, setInputSearchValues] = useState({});
    const [searchModalVisible, setSearchEditModalVisible] = useState(false);
    const [editModalVisible, setEditModalVisible] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [deleteModalVisible, setDeleteModalVisible] = useState(false);
    const [listPagination, setlistPagination] = useState({
        totalItemCount: 0,
        pageSize: 10,
        pageNumber: 1,
    });
    const {userData, userManager} = useAuth();
    const [form] = Form.useForm();

    const token = userData?.access_token;
    const {decodedToken} = useJwt(token);
    const userEmail = decodedToken?.email;

    const pageSEOSettings = {
        title: "Labels List",
    };

    useEffect(() => {
        searchLabel();
        getReferenceKvps();
    }, []);
    useEffect(() => {
        searchLabel();
    }, [inputSearchValues]);

    useEffect(() => {
        if (listPagination.totalItemCount !== 0) {
            searchLabel();
        }
    }, [listPagination.pageNumber, sortedInfo]);

    const showDeleteModal = (record) => {
        setSelectedRecord(record);
        setDeleteModalVisible(true);
    };
    const handleDelete = () => {
        // Add your delete logic here using selectedRecord
        deleteDocumentLabel(selectedRecord);
        setDeleteModalVisible(false);
    };
    const handleCancel = () => {
        setAddModalVisible(false);
        setEditModalVisible(false);
        setDeleteModalVisible(false);
    };

    const getReferenceKvps = async () => {
        setloading(true);
        try {
            const response = await SharedService.get({
                token,
                url: "reference/kvps",
            });
            setReferenceKvps(response);
            setloading(false);
        } catch (error) {
            if (error.response && error.response.status === 500) {
                notification.error({
                    message: "Error",
                    description: error.response.statusText,
                });
            }
            if (error.response && error.response.status === 502) {
                notification.error({
                    message: "Error",
                    description: error.response.statusText,
                });
            }
        }
    };

    const fetchDocumentLabels = async () => {
        setloading(true);
        try {
            const response = await SharedService.get({
                token,
                url: "documentlabels",
            });

            setDocumentLabels(response.items);
            setlistPagination({
                ...listPagination,
                totalItemCount: response.totalItemCount,
            });

            setloading(false);
        } catch (error) {
            if (error.response && error.response.status === 500) {
                notification.error({
                    message: "Error",
                    description: error.response.statusText,
                });
            }
            if (error.response && error.response.status === 502) {
                notification.error({
                    message: "Error",
                    description: error.response.statusText,
                });
            }
        }
    };
    const deleteDocumentLabel = (id) => {
        setloading(true);

        SharedService.delete({token, url: `documentlabel/${id}`})
            .then(() => {
                setloading(false);
                notification.success({
                    message: "Deleted Successfully",
                });
                searchLabel();
            })
            .catch((error) => {
                setloading(false);
                if (error.response && error.response.status === 500) {
                    notification.error({
                        message: "Error",
                        description: error.response.statusText,
                    });
                }
                if (error.response && error.response.status === 502) {
                    notification.error({
                        message: "Error",
                        description: error.response.statusText,
                    });
                }
            });
    };
    const showEditModal = (record) => {
        form.setFieldsValue({
            editid: record.id,
            editkey: record.key,
            editisActive: record.isActive,
            editpriority: record.priority,
            editsearchValue: record.searchValue,
        });

        setEditModalVisible(true);
    };

    const addDocumentLabels = (key, priority, searchValue, active) => {
        setloading(true);
        const data = {
            searchValue: searchValue,
            key: key,
            isActive: Boolean(active),
            priority: parseInt(priority, 10),
            updatedBy: userEmail,
        };

        return SharedService.post({token, url: "documentlabels", data})
            .then(() => {
                notification.success({
                    message: "Updated Successfully",
                });
                searchLabel(); // If fetchWhiteList updates the state with the new data, you may not need this line.
                setloading(false);
            })
            .catch((error) => {
                setloading(false);
                if (error.response && error.response.status === 500) {
                    notification.error({
                        message: "Error",
                        description: error.response.statusText,
                    });
                }
                if (error.response && error.response.status === 502) {
                    notification.error({
                        message: "Error",
                        description: error.response.statusText,
                    });
                }
                return false;
            });
    };

    const editLabel = (id, key, priority, searchValue, active) => {
        setloading(true);
        const data = {
            id: id,
            searchValue: searchValue,
            key: key,
            isActive: Boolean(active),
            priority: parseInt(priority, 10),
            updatedBy: userEmail,
        };

        return SharedService.post({token, url: "documentlabels", data})
            .then(() => {
                notification.success({
                    message: "Updated Successfully",
                });
                searchLabel(); // If fetchWhiteList updates the state with the new data, you may not need this line.
                setloading(false);
            })
            .catch((error) => {
                setloading(false);
                if (error.response && error.response.status === 500) {
                    notification.error({
                        message: "Error",
                        description: error.response.statusText,
                    });
                }
                if (error.response && error.response.status === 502) {
                    notification.error({
                        message: "Error",
                        description: error.response.statusText,
                    });
                }
                return false;
            });
    };

    const searchLabel = async (values) => {
        setloading(true);
        let data = {};
        if (values && values !== undefined) {
            data = values;
        } else {
            data = inputSearchValues;
        }

        const params = {
            pageNumber: listPagination.pageNumber,
            pageSize: listPagination.pageSize,
            orderBy: sortedInfo.order
                ? `${sortedInfo.columnKey}:${
                    sortedInfo.order === "ascend" ? "Asc" : "Desc"
                }`
                : "id:Desc",
        };

        try {
            const response = await SharedService.post({
                token,
                url: "documentlabels/search",
                data,
                params,
            });
            // If fetchWhiteList updates the state with the new data, you may not need this line.
            setDocumentLabels(response.items);
            setlistPagination({
                ...listPagination,
                totalItemCount: response.totalItemCount,
            });
            setloading(false);
        } catch (error) {
            setloading(false);
            if (
                error.response &&
                (error.response.status === 500 || error.response.status === 502)
            ) {
                notification.error({
                    message: "Error",
                    description: error.response.statusText,
                });
            }
        }
    };

    const handleAdd = () => {
        form.validateFields().then((values) => {

            addDocumentLabels(
                values.addkey,
                parseInt(values.addpriority, 10),
                values.addsearchValue,
                Boolean(values.addactive[0])
            );
            form.resetFields();
            setAddModalVisible(false);
        });
    };

    const handleEdit = () => {
        // Add your edit logic here using selectedRecord
        form.validateFields().then((values) => {
            // Add your logic to handle the new record (values.email)
            form.resetFields();
            editLabel(
                parseInt(values.editid, 10),
                values.editkey,
                parseInt(values.editpriority, 10),
                values.editsearchValue,
                values.editisActive
            );
        });
        setEditModalVisible(false);
    };

    const showAddModal = () => {
        setAddModalVisible(true);
    };
    const tableConfig = {
        rowKey: "id",
    };
    const columns = [
        {
            title: "ID",
            key: "id",
            dataIndex: "id",
            render: (id) => {
                return (
                    <Tooltip title={id} placement="topLeft">
                        <div>{id}</div>
                    </Tooltip>
                );
            },
            width: 100,

            align: "left",
            sorter: true,
            sortOrder: sortedInfo.columnKey === "id" && sortedInfo.order,
        },
        {
            title: "Key",
            key: "key",
            dataIndex: "key",
            render: (value) => {
                return (
                    <Tooltip title={value} placement="topLeft">
                        <div>{value}</div>
                    </Tooltip>
                );
            },
            width: 300,
            sorter: true,
            sortOrder: sortedInfo.columnKey === "key" && sortedInfo.order,
        },
        {
            title: "Is Active",
            key: "isActive",
            dataIndex: "isActive",
            render: (value) => {
                return (
                    <Tooltip title={value === true ? "Yes" : "No"} placement="topLeft">
                        <div>{value === true ? "Yes" : "No"} </div>
                    </Tooltip>
                );
            },
            width: 200,
            sorter: true,
            sortOrder: sortedInfo.columnKey === "isActive" && sortedInfo.order,
        },
        {
            title: "Priority",
            key: "priority",
            dataIndex: "priority",
            render: (value) => {
                return (
                    <Tooltip title={value} placement="topLeft">
                        <div>{value}</div>
                    </Tooltip>
                );
            },
            width: 200,
            sorter: true,
            sortOrder: sortedInfo.columnKey === "priority" && sortedInfo.order,
        },
        {
            title: "Search Value",
            key: "searchValue",
            dataIndex: "searchValue",
            render: (value) => {
                return (
                    <Tooltip title={value} placement="topLeft">
                        <div>{value}</div>
                    </Tooltip>
                );
            },
            sorter: true,
            width: 300,
            sortOrder: sortedInfo.columnKey === "searchValue" && sortedInfo.order,
        },
        {
            title: "Updated By",
            key: "updatedBy",
            dataIndex: "updatedBy",
            render: (value) => {
                return (
                    <Tooltip title={value} placement="topLeft">
                        <div>{value}</div>
                    </Tooltip>
                );
            },
            width: 300,
            sorter: true,
            sortOrder: sortedInfo.columnKey === "updatedBy" && sortedInfo.order,
        },

        {
            title: (
                <div className="grid grid-cols-12">
                    <div className="col-span-6"></div>
                    <div className="col-span-6 ">Actions</div>
                </div>
            ),
            key: "actions",

            render: (text, record) => (
                <div className="flex justify-end gap-3">
                    <Tooltip title="Edit">
                        <EditOutlined
                            style={{fontSize: 20}}
                            onClick={() => showEditModal(record)}
                            className="cursor-pointer"
                        />
                    </Tooltip>
                    <Tooltip title="Delete">
                        <DeleteOutlined
                            style={{fontSize: 20}}
                            onClick={() => showDeleteModal(record.id)}
                            className="cursor-pointer text-red-500"
                        />
                    </Tooltip>
                </div>
            ),
        },
    ];
    const paginationProps = {
        showSizeChanger: false,
        total: listPagination.totalItemCount,
        pageSize: listPagination.pageSize,
        current: listPagination.pageNumber,
    };
    const handleTableChange = (pagination, filters, sorter) => {
        setSortedInfo(sorter);

        setlistPagination({...listPagination, pageNumber: pagination.current});
    };

    const handleInputChange = () => {
        form.setFieldsValue({
            id: inputSearchValues.id,
            searchValue: inputSearchValues.searchValue,
            key: inputSearchValues.key,
            isActive: inputSearchValues.isActive,
            priority: inputSearchValues.priority,
        });
        setSearchEditModalVisible(true);
    };

    const handleSearchCancel = () => {
        setInputSearchValues({});
        setSearchEditModalVisible(false);
    };
    const handleSearch = () => {
        form.validateFields().then((values) => {
            // Add your logic to handle the new record (values.email)

            form.resetFields();
            setInputSearchValues((prevValues) => ({
                ...prevValues,
                ...values,
            }));
            setSearchEditModalVisible(false);
            listPagination.pageNumber = 1;
            searchLabel(values);
        });
    };
    const handleTagClose = (key) => {
        setInputSearchValues((prevValues) => {
            const updatedValues = {...prevValues};
            delete updatedValues[key];
            return updatedValues;
        });
    };
    return (
        <div>
            <SEO {...pageSEOSettings} />
            <div className="px-4 sm:px-7 py-5">
                <div className="flex items-start gap-4 flex-wrap">
                    <div className="flex-1 min-w-0">
                        <div className="text-[22px] font-semibold text-[#0B1220] leading-tight">Document labels</div>
                        <div className="text-[13px] text-[#7A849A] mt-1">
                            Rules for auto-classifying incoming documents based on content keywords.
                        </div>
                    </div>
                    <Button type="primary" onClick={showAddModal}>Add label</Button>
                </div>
            </div>

            <div className="px-4 sm:px-7 pb-7 relative">
                {loading && (
                    <div className="absolute inset-0 flex justify-center items-center bg-white bg-opacity-50 z-10 rounded-[14px]">
                        <Spin size="large" className="custom-spin"/>
                    </div>
                )}

                <div className="flex items-center gap-3 flex-wrap mb-4">
                    {Object.entries(inputSearchValues)
                        .filter(([, value]) => value !== undefined && value !== null && value !== "")
                        .map(([label, value]) => (
                            <Tag
                                key={label}
                                closable
                                onClose={() => handleTagClose(label)}
                                className="!m-0 inline-flex items-center gap-1 px-2.5 py-1 rounded-full"
                                style={{backgroundColor: "#ECF9EE", color: "#1B7A31", border: "1px solid #C8E9CD"}}
                            >
                                <span className="font-semibold">{label}:</span>{" "}
                                {typeof value === "boolean" ? (value ? "Yes" : "No") : value}
                            </Tag>
                        ))}
                    <div className="flex-1"/>
                    <Button icon={<FilterOutlined/>} onClick={handleInputChange}>Filters</Button>
                </div>

                <Table
                    {...tableConfig}
                    dataSource={documentLabels}
                    pagination={paginationProps}
                    columns={columns}
                    onChange={handleTableChange}
                />
                <Modal
                    title="Delete label"
                    open={deleteModalVisible}
                    onOk={handleDelete}
                    onCancel={handleCancel}
                    okText="Delete"
                    okButtonProps={{danger: true}}
                    cancelText="Cancel"
                    centered
                >
                    <div className="text-[14px] text-[#374152]">
                        Are you sure you want to delete this label?
                    </div>
                </Modal>

                <Modal
                    title="Edit label"
                    open={editModalVisible}
                    onOk={handleEdit}
                    onCancel={handleCancel}
                    okText="Save"
                    cancelText="Cancel"
                >
                    {/* Your edit form content here */}
                    <Form form={form} layout="vertical">
                        <Form.Item
                            name="editid"
                            label={<span className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide">ID</span>}
                        >
                            <Input
                                readOnly
                                disabled={true}
                            />
                        </Form.Item>

                        <Form.Item
                            name="editkey"
                            label={<span className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide">Key</span>}
                        >
                            <Select

                                placeholder="Select"
                                className="w-full"
                
                                allowClear
                                showSearch // Enable search functionality
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    (option?.props?.value ?? "")
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                }
                            >
                                {referenceKvps.map((option) => (
                                    <Option key={option.value} value={option.id}>
                                        {option.id}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            name="editisActive"
                            label={<span className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide">Is Active</span>}
                        >
                            <Radio.Group>
                                <Radio value={true}>True</Radio>
                                <Radio value={false}>False</Radio>
                            </Radio.Group>
                        </Form.Item>

                        <Form.Item
                            name="editpriority"
                            label={<span className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide">Priority</span>}
                        >
                            <Input placeholder="Enter the Priority"/>
                        </Form.Item>
                        <Form.Item
                            name="editsearchValue"
                            label={<span className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide">Search Value</span>}
                        >
                            <Input placeholder="Enter the Search Value"/>
                        </Form.Item>
                    </Form>
                </Modal>

                <Modal
                    title="Add document label"
                    open={addModalVisible}
                    onOk={handleAdd}
                    onCancel={handleCancel}
                    okText="Add"
                    cancelText="Cancel"
                >
                    <Form form={form} layout="vertical">
                        <Form.Item
                            name="addkey"
                            label={<span className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide">Key</span>}
                        >
                            <Select
                                placeholder="Select"
                                className="w-full"
                
                                allowClear
                                showSearch // Enable search functionality
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    (option?.props?.value ?? "")
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                }
                            >
                                {referenceKvps.map((option) => (
                                    <Option key={option.value} value={option.id}>
                                        {option.id}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <Form.Item
                            name="addpriority"
                            label={<span className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide">Priority</span>}
                        >
                            <Input placeholder="Enter the Priority"/>
                        </Form.Item>
                        <Form.Item
                            name="addactive"
                            label={<span className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide">Is Active</span>}
                        >
                            <Radio.Group>
                                <Radio value={true}>True</Radio>
                                <Radio value={false}>False</Radio>
                            </Radio.Group>
                        </Form.Item>
                        <Form.Item
                            name="addsearchValue"
                            label={<span className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide">Search Value</span>}
                        >
                            <Input placeholder="Enter the Search Value"/>
                        </Form.Item>
                    </Form>
                </Modal>

                <Modal
                    title="Advanced Search"
                    open={searchModalVisible}
                    onOk={handleSearch}
                    onCancel={handleSearchCancel}
                    okText="Search"
                    cancelText="Cancel"
                    width={560}
                >
                    {/* Your edit form content here */}
                    <Form form={form} layout="vertical">
                        <Form.Item
                            name="id"
                            label={<span className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide">ID</span>}
                        >
                            <InputNumber className="w-full" placeholder="Enter the Id "/>
                        </Form.Item>
                        <Form.Item
                            name="key"
                            label={<span className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide">Key</span>}
                        >
                            <Select
                                placeholder="Select"
                                className="w-full"
                
                                allowClear
                                showSearch // Enable search functionality
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    (option?.props?.value ?? "")
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                }
                            >
                                {referenceKvps.map((option) => (
                                    <Option key={option.value} value={option.id}>
                                        {option.id}
                                    </Option>
                                ))}</Select>

                        </Form.Item>
                        <Form.Item
                            name="searchValue"
                            label={<span className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide">Search Value</span>}
                        >
                            <Input placeholder="Enter the search Value"/>
                        </Form.Item>
                        <Form.Item
                            name="priority"
                            label={<span className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide">Priority</span>}
                        >
                            <Input type="number" placeholder="Enter the priority "/>
                        </Form.Item>
                        <Form.Item
                            name="updatedBy"
                            label={<span className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide">Updated By</span>}
                        >
                            <Input placeholder="Enter the updatedBy "/>
                        </Form.Item>
                        <Form.Item
                            name="isActive"
                            label={<span className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide">Is Active</span>}
                        >
                            <Radio.Group>
                                <Radio value={true}>True</Radio>
                                <Radio value={false}>False</Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Form>
                </Modal>
            </div>
        </div>
    );
};

export default DocumentLabels;
